import { render, staticRenderFns } from "./promotionalBeltList.vue?vue&type=template&id=359a174f&scoped=true&"
import script from "./promotionalBeltList.vue?vue&type=script&lang=js&"
export * from "./promotionalBeltList.vue?vue&type=script&lang=js&"
import style0 from "./promotionalBeltList.vue?vue&type=style&index=0&id=359a174f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a174f",
  null
  
)

component.options.__file = "promotionalBeltList.vue"
export default component.exports